// Level display ordering — Program first (CRM-57), then descending competitive
// level; unknown levels sort after the known list, alphabetically.
export const KNOWN_LEVELS = ['Program', 'Varsity', 'JV', 'Freshman', 'Froshsoph', 'Sophomore', 'Alumni'] as const;

// Single lowercase-keyed Map: case-insensitive by construction, and immune to
// the Object.prototype trap (e.g. a level literally named 'constructor').
const LEVEL_RANK = new Map<string, number>(KNOWN_LEVELS.map((l, i) => [l.toLowerCase(), i] as const));

export function levelRank(level: string): number {
  return LEVEL_RANK.get(level.toLowerCase()) ?? 99;
}

export function compareLevels(a: string, b: string): number {
  const ra = levelRank(a);
  const rb = levelRank(b);
  return ra !== rb ? ra - rb : a.localeCompare(b);
}
